import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@surfline/quiver-react';
import config from '../../config';

class RedeemError extends Component {
  getErrorHeader = () => 'This code cannot be redeemed.';

  getErrorMessage = () => {
    const {
      validationErrorCode
    } = this.props;

    if (validationErrorCode === 1003) {
      return `There is an outstanding issue with this gift card.
        We are unable to apply this gift card to your account.`;
    }
    if (validationErrorCode === 1002) {
      return `Your current subscription is managed by a 3rd party.
        We are unable to apply this gift card to your account.`;
    }
    if (validationErrorCode === 1003) {
      return `Your current subscription billing has been disputed.
      We are unable to apply this gift card to your account.`;
    }

    return `There was a problem applying this gift card to your account.
      Please try again or contact support@surfline.com`;
  }

  navigateToHelp = () => (
    window.location.assign(config.giftRedeemHelpUrl)
  )

  render() {
    const { doResetRedeem } = this.props;
    return (
      <div>
        <h4>{this.getErrorHeader()}</h4>
        <p>{this.getErrorMessage()}</p>
        <Button onClick={this.navigateToHelp}>Learn More</Button>
        <Button onClick={() => doResetRedeem()} type="info">Cancel</Button>
      </div>
    );
  }
}

RedeemError.propTypes = {
  validationErrorCode: PropTypes.number,
  doResetRedeem: PropTypes.func.isRequired,
};

RedeemError.defaultProps = {
  validationErrorCode: null,
};

export default RedeemError;
